import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'dashboard',
    templateUrl: 'component.html',
    standalone: false
})
export class Dashboard implements OnInit {
  public selectedIndex: number;

  public currentTab = new BehaviorSubject<string>(null);
  public availableTabs;
  public queryParams;

  public tabs: { [key: string]: boolean } = {
    admin: null,
    reporting: null,
    'listing-admin': null,
    'event-admin': null,
    'categories-admin': null,
    'organisation-admin': null,
    'user-admin': null,
    'retired-user-admin': null,
    'all-admin-users': null,
    'finance-admin': null,
    'local-offers-admin': null,
    'homepage-admin': null,
    'audit-admin': null,
    'notification-admin': null,
  };

  tabChanged = (TabChangeEvent: MatTabChangeEvent): void => {
    const role = TabChangeEvent.tab.textLabel;
    this.currentTab.next(role);
    this.Router.navigate(['dashboard', role], {
      queryParams: this.queryParams,
    });
    this.queryParams = {};
  };

  constructor(
    private Router: Router,
    private ActivatedRoute: ActivatedRoute,
    private Auth: AuthService,
  ) {}

  ngOnInit(): void {
    const currentTab = this.ActivatedRoute.snapshot.params['tab'];
    const roles = Object.keys(this.tabs);

    roles.forEach((role) => {
      this.tabs[role] = this.Auth.inGroup(role);
      if (this.tabs['admin'] === true && !this.Auth.inGroup('branch-admin')) {
        this.tabs['local-offers-admin'] = true;
        this.tabs['homepage-admin'] = true;
      } else if (
        role === 'listing-admin' ||
        role === 'event-admin' ||
        (role === 'organisation-admin' && this.Auth.inGroup('branch-admin'))
      ) {
        this.tabs['listing-admin'] = true;
        this.tabs['admin'] = false;
        this.tabs['event-admin'] = false;
        this.tabs['organisation-admin'] = false;
        this.tabs['local-offers-admin'] = false;
      }
    });
    this.tabs['reporting'] = this.tabs['admin'];
    this.availableTabs = roles.filter((tab) => this.tabs[tab]);
    this.selectedIndex = this.availableTabs.indexOf(currentTab);

    if (this.selectedIndex === -1) {
      this.Router.navigate(['dashboard', this.availableTabs[0]]).then(() => {
        window.location.reload();
      });
    }
    this.currentTab.next(this.availableTabs[this.selectedIndex]);
  }

  setTab(event) {
    this.queryParams = {};
    const { role, catKey, catValue } = event;
    this.queryParams[catKey] = catValue;
    this.queryParams[event.typeKey] = event.typeKey && event.typeValue;
    this.selectedIndex = this.availableTabs.indexOf(role);
  }
}
